export default __webpack_public_path__ + "static/media/intro.e402398d.mp3";